var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep8Off(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4335_37995)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FDFDFD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 37V32.75C17 32.1479 17.2047 31.6432 17.6142 31.2359C18.0237 30.8286 18.5159 30.625 19.0909 30.625H22.5148C22.8633 30.625 23.1943 30.7135 23.508 30.8906C23.8216 31.0677 24.0742 31.3068 24.2659 31.6078C24.7712 32.2984 25.3941 32.8385 26.1347 33.2281C26.8752 33.6177 27.6636 33.8125 28.5 33.8125C29.3538 33.8125 30.1509 33.6177 30.8915 33.2281C31.632 32.8385 32.2462 32.2984 32.7341 31.6078C32.9606 31.3068 33.2263 31.0677 33.5312 30.8906C33.8362 30.7135 34.1542 30.625 34.4852 30.625H37.9091C38.5015 30.625 38.9981 30.8286 39.3989 31.2359C39.7996 31.6432 40 32.1479 40 32.75V37H32.6818V34.5828C32.072 35.0255 31.4142 35.362 30.7085 35.5922C30.0028 35.8224 29.2667 35.9375 28.5 35.9375C27.7508 35.9375 27.0189 35.818 26.3045 35.5789C25.5902 35.3398 24.928 34.999 24.3182 34.5562V37H17ZM28.5 32.75C27.8379 32.75 27.2106 32.5951 26.6182 32.2852C26.0258 31.9753 25.5292 31.5458 25.1284 30.9969C24.8322 30.5542 24.4619 30.2044 24.0176 29.9477C23.5733 29.6909 23.0898 29.5625 22.567 29.5625C22.9504 28.9073 23.7606 28.3893 24.9977 28.0086C26.2348 27.6279 27.4023 27.4375 28.5 27.4375C29.5977 27.4375 30.7652 27.6279 32.0023 28.0086C33.2394 28.3893 34.0496 28.9073 34.433 29.5625C33.9277 29.5625 33.4485 29.6909 32.9955 29.9477C32.5424 30.2044 32.1678 30.5542 31.8716 30.9969C31.4883 31.5635 31.0004 31.9974 30.408 32.2984C29.8155 32.5995 29.1795 32.75 28.5 32.75ZM20.1364 29.5625C19.2652 29.5625 18.5246 29.2526 17.9148 28.6328C17.3049 28.013 17 27.2604 17 26.375C17 25.4719 17.3049 24.7148 17.9148 24.1039C18.5246 23.493 19.2652 23.1875 20.1364 23.1875C21.025 23.1875 21.7699 23.493 22.371 24.1039C22.9722 24.7148 23.2727 25.4719 23.2727 26.375C23.2727 27.2604 22.9722 28.013 22.371 28.6328C21.7699 29.2526 21.025 29.5625 20.1364 29.5625ZM36.8636 29.5625C35.9924 29.5625 35.2519 29.2526 34.642 28.6328C34.0322 28.013 33.7273 27.2604 33.7273 26.375C33.7273 25.4719 34.0322 24.7148 34.642 24.1039C35.2519 23.493 35.9924 23.1875 36.8636 23.1875C37.7523 23.1875 38.4972 23.493 39.0983 24.1039C39.6994 24.7148 40 25.4719 40 26.375C40 27.2604 39.6994 28.013 39.0983 28.6328C38.4972 29.2526 37.7523 29.5625 36.8636 29.5625ZM28.5 26.375C27.6288 26.375 26.8883 26.0651 26.2784 25.4453C25.6686 24.8255 25.3636 24.0729 25.3636 23.1875C25.3636 22.2844 25.6686 21.5273 26.2784 20.9164C26.8883 20.3055 27.6288 20 28.5 20C29.3886 20 30.1335 20.3055 30.7347 20.9164C31.3358 21.5273 31.6364 22.2844 31.6364 23.1875C31.6364 24.0729 31.3358 24.8255 30.7347 25.4453C30.1335 26.0651 29.3886 26.375 28.5 26.375Z",
    fill: "#D1D5D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4335_37995",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.835294 0 0 0 0 0.847059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4335_37995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4335_37995",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep8Off);
export default __webpack_public_path__ + "static/media/step8-off.073b844012eeef7717190716d0fd737a.svg";
export { ForwardRef as ReactComponent };